import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';
import { message } from 'antd';
import { SET_BOOKING_STATUS } from 'common/queries/booking';
import { orderStage } from 'common/constants/booking';

export const useBookingStatusModal = props => {
  const { id, stage, visible, onClose, onSuccess } = props;
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [newStage, setNewStage] = useState(null);
  const [options, setOptions] = useState([]);

  const [updateBookingStatus] = useMutation(SET_BOOKING_STATUS);

  const handleCloseStatus = () => {
    setOptions([]);
    setNewStage(null);
    onClose?.();
  };

  const handleSelectChange = value => {
    setNewStage(value);
  };

  const handleUpdateStatus = async () => {
    setLoading(true);
    try {
      await updateBookingStatus({ variables: { input: { id, stage: newStage } } });
      message.success(t('cms:cms.booking.modal.status.update_success'));
      onSuccess?.();
      handleCloseStatus();
    } catch (error) {
      message.error(error?.message?.toString());
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (stage === orderStage.IN_PROGRESS) {
      setOptions([
        { value: orderStage.LOST, text: t('cms:cms.booking.modal.stage.lost') },
        { value: orderStage.COMPLETED, text: t('cms:cms.booking.modal.stage.completed') },
      ]);
    } else if (stage === orderStage.COMPLETED) {
      setOptions([
        { value: orderStage.CANCELLED, text: t('cms:cms.booking.modal.stage.cancelled') },
      ]);
    } else {
      setOptions([]);
    }
    setNewStage(undefined);
  }, [stage, visible]);

  return {
    visible,
    loading,
    options,
    newStage,
    t,
    setNewStage,
    handleCloseStatus,
    handleUpdateStatus,
    handleSelectChange,
  };
};
